import ActivitiesStore from './ActivitiesStore';
import AuthStore from './AuthStore';
import DailyHabitsStore from './DailyHabitsStore';
import HealthGoalsStore from './HealthGoalsStore';
import HealthTrackersStore from './HealthTrackersStore';
import HomeWidgetTextStore from './HomeWidgetTextStore';
import ProfileStore from './ProfileStore';
import RewardsStore from './RewardsStore';
import TeamsUserStore from './TeamsUserStore';

export class RootStore {
  teamsUserStore = new TeamsUserStore(this);
  authStore = new AuthStore(this);
  profileStore = new ProfileStore(this);
  rewardsStore = new RewardsStore(this);
  activitiesStore = new ActivitiesStore(this);
  dailyHabitsStore = new DailyHabitsStore(this);
  healthTrackersStore = new HealthTrackersStore(this);
  homeWidgetTextStore = new HomeWidgetTextStore(this);
  healthGoalsStore = new HealthGoalsStore(this);
}

export const rootStoreInstance = new RootStore();
